import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PSelectItem } from '../../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-bien-viticole-form',
  templateUrl: './bien-viticole-form.component.html',
  styleUrls: ['./bien-viticole-form.component.scss'],
})
export class BienViticoleFormComponent implements OnChanges {
  @Input() bienViticole!: Report.Characteristics.BienViticole | undefined;
  @Input() constructionYear!: number;

  @Output() bienViticoleChanged =
    new EventEmitter<Report.Characteristics.BienViticole>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  bienViticoleForm = new FormGroup({
    propertyType: new FormControl('Bien viticole', { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    vineyardAreaHa: new FormControl(''),
    farmBuildingsAreaM2: new FormControl(''),
    residentialBuildingsAreaM2: new FormControl(''),
    grapeVarieties: new FormControl(''),
    appellation: new FormControl(''),
  });

  hasFarmBuildingsItem!: PSelectItem;
  hasResidentialBuildingItem!: PSelectItem;

  yesNoSelectItems: PSelectItem[] = [
    { value: 'yes', label: 'Oui' },
    { value: 'no', label: 'Non' },
  ];

  bienViticoleInternal!: Report.Characteristics.BienViticole;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bienViticole'] && changes['bienViticole'].currentValue) {
      this.bienViticoleInternal = changes['bienViticole'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.bienViticoleForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onHasFarmBuildingsSelected({ value }: PSelectItem): void {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      hasFarmBuildings: value === 'yes',
    };

    this.hasFarmBuildingsItem = { value };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onHasResidentialBuilding({ value }: PSelectItem): void {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      hasResidentialBuilding: value === 'yes',
    };

    this.hasResidentialBuildingItem = { value };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onVineyardAreaHaChanged(event: Event) {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      vineyardAreaHa: parseFloat((event.target as HTMLInputElement).value),
    };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onFarmBuildingsAreaM2Changed(event: Event) {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      farmBuildingsAreaM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onResidentialBuildingsAreaM2Changed(event: Event) {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      residentialBuildingsAreaM2: parseInt(
        (event.target as HTMLInputElement).value,
      ),
    };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onGrapeVarietiesChanged(event: Event) {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      grapeVarieties: (event.target as HTMLInputElement).value,
    };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  onAppellationChanged(event: Event) {
    this.bienViticoleInternal = {
      ...this.bienViticoleInternal,
      appellation: (event.target as HTMLInputElement).value,
    };

    this.bienViticoleChanged.emit(this.bienViticoleInternal);
  }

  setFormValues(): void {
    this.bienViticoleForm.controls.constructionYear.setValue(
      this.constructionYearinternal
        ? this.constructionYearinternal.toString()
        : '',
    );

    this.bienViticoleForm.controls.vineyardAreaHa.setValue(
      this.bienViticoleInternal?.vineyardAreaHa?.toString() || '',
    );

    this.bienViticoleForm.controls.farmBuildingsAreaM2.setValue(
      this.bienViticoleInternal?.farmBuildingsAreaM2?.toString() || '',
    );

    this.bienViticoleForm.controls.residentialBuildingsAreaM2.setValue(
      this.bienViticoleInternal?.residentialBuildingsAreaM2?.toString() || '',
    );

    this.bienViticoleForm.controls.grapeVarieties.setValue(
      this.bienViticoleInternal?.grapeVarieties || '',
    );

    this.bienViticoleForm.controls.appellation.setValue(
      this.bienViticoleInternal?.appellation || '',
    );

    if (!this.bienViticoleInternal.hasFarmBuildings) {
      this.bienViticoleInternal.hasFarmBuildings = false;
    }

    if (!this.bienViticoleInternal.hasResidentialBuilding) {
      this.bienViticoleInternal.hasResidentialBuilding = false;
    }

    this.hasFarmBuildingsItem = this.bienViticoleInternal?.hasFarmBuildings
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];

    this.hasResidentialBuildingItem = this.bienViticoleInternal
      ?.hasResidentialBuilding
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];
  }
}
